import { render } from "./UserProfile.vue?vue&type=template&id=22540cf6&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-22540cf6"

export default script